import { render } from "./App.vue?vue&type=template&id=50205392"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=50205392&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__